export function ErrorBanner({ error, onDismiss }) {
  if (!error) return null;

  const details = error.fieldErrors?.length
    ? error.fieldErrors.map((item) => `${item.field}: ${item.message}`).join(' · ')
    : null;

  return (
    <div className="banner banner-error" role="alert">
      <span>
        {error.message}
        {details ? ` — ${details}` : ''}
      </span>
      {onDismiss && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={onDismiss}>
          Dismiss
        </button>
      )}
    </div>
  );
}

export function InfoBanner({ children }) {
  if (!children) return null;
  return <div className="banner banner-info">{children}</div>;
}

export function Toast({ message, onDone }) {
  if (!message) return null;
  return (
    <div className="toast" role="status" onAnimationEnd={onDone}>
      {message}
    </div>
  );
}
